export default function SuccessStoriesSection() {
  const stories = [
    {
      name: 'Maria Rodriguez',
      location: 'East El Paso',
      situation: 'Job Loss & Medical Bills',
      story: 'After losing my job and facing unexpected medical bills, I fell three months behind on my mortgage. The foreclosure notice came, and I was terrified. T-Rex Real Estate gave me a fair cash offer within 24 hours and closed in 9 days. I was able to avoid foreclosure, pay off my debts, and move to a more affordable apartment. They saved my credit score and gave me a fresh start.',
      image: 'https://public.readdy.ai/ai/img_res/fbd07c0df1837ea3c1d3e7e69349b68b.jpg'
    },
    {
      name: 'James Thompson',
      location: 'West El Paso',
      situation: 'Divorce Settlement',
      story: 'My divorce left me with a house I couldn\'t afford and a mortgage that was underwater. I was two months from foreclosure when I found T-Rex Real Estate. They understood my situation, worked with my lender, and bought my house as-is. I didn\'t have to make any repairs or pay realtor fees. They helped me avoid foreclosure and move forward with my life.',
      image: 'https://readdy.ai/api/search-image?query=middle-aged-man-smiling-confidently-in-casual-business-attire-professional-portrait-photography-showing-relief-and-new-beginning-natural-lighting-realistic-warm-tones-positive-expression&width=400&height=400&seq=success-story-james-016&orientation=squarish'
    },
    {
      name: 'The Martinez Family',
      location: 'Northeast El Paso',
      situation: 'Business Failure',
      story: 'When our family business failed, we couldn\'t keep up with the mortgage on our home. We received the Notice of Trustee Sale and had only 21 days before the auction. T-Rex Real Estate moved incredibly fast - they made us an offer the same day we called and closed in 7 days. We avoided foreclosure, protected our credit, and had enough money to relocate and start over.',
      image: 'https://readdy.ai/api/search-image?query=hispanic-family-of-three-parents-and-child-smiling-together-in-bright-home-setting-professional-family-portrait-showing-relief-and-happiness-natural-lighting-realistic-warm-welcoming-atmosphere&width=400&height=400&seq=success-story-martinez-017&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-bold mb-6">
            Real Stories from Real People
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            How We've Helped El Paso Homeowners Avoid Foreclosure
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            These are just a few of the hundreds of El Paso families we've helped avoid foreclosure and move forward with their lives. Your success story could be next.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {stories.map((story, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img 
                src={story.image} 
                alt={`${story.name} avoided foreclosure`} 
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">{story.name}</h3>
                    <p className="text-sm text-gray-600">{story.location}</p>
                  </div>
                  <div className="flex text-yellow-500">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
                <div className="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-bold mb-4">
                  {story.situation}
                </div>
                <p className="text-base text-gray-700 leading-relaxed italic">
                  "{story.story}"
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-black mb-4">
            Join Hundreds of Satisfied Homeowners
          </h3>
          <p className="text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            We've helped over 500 El Paso families avoid foreclosure and protect their financial futures. Let us help you write your own success story.
          </p>
          <div className="grid md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div>
              <div className="text-4xl font-black text-teal-400 mb-2">500+</div>
              <p className="text-sm">Foreclosures Prevented</p>
            </div>
            <div>
              <div className="text-4xl font-black text-teal-400 mb-2">7 Days</div>
              <p className="text-sm">Average Closing Time</p>
            </div>
            <div>
              <div className="text-4xl font-black text-teal-400 mb-2">$0</div>
              <p className="text-sm">Fees or Commissions</p>
            </div>
            <div>
              <div className="text-4xl font-black text-teal-400 mb-2">100%</div>
              <p className="text-sm">Satisfaction Rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}